import 'jquery';
import 'bootstrap';
import '@fancyapps/fancybox';
import './Components/objectFitPolyfill';

import {Tracking} from "../../../../vet_tracking/Resources/Private/JavaScript/Components/tracking.js";
import {AppInstall} from "./Components/appInstall";
import {ankerMenu} from "./Components/ankerMenu";
import {webinarSlider} from './Components/webinarSlider';
import {stickyMenu} from "./Components/stickyMenu";
import {GsAcknowledgePopup} from "./Components/gsAcknowledgePopup";
import {OffCanvasMenu} from './Components/offCanvasMenu';
import {Faq} from './Components/faq.js';

// Set right namespace for Tracking attribute by Webinar and Download Slider in Tradeshow
$('.c-exhibitor__detail[data-tracking-namespace]').each(function () {
    let $this = $(this);
    $this.find('.c-download__wrap, .c-slider__link').attr('data-tracking-sponsor', $this.data('tracking-namespace'));
});

(function ($) {
    let tracking = new Tracking();
    new AppInstall();
    new OffCanvasMenu();
    new ankerMenu();
    new webinarSlider();
    new stickyMenu();
    new GsAcknowledgePopup();
    new Faq();

    $('[data-toggle="tooltip"]').tooltip();
    $(document).on('show.bs.collapse', '.collapse', function (e) {
        tracking.click($(this), e);
    })
})(jQuery);

// Register service worker
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/gssw.js')
        .then(registration => {
            console.log('service worker registered');
            // update service worker manually every 12 hours
            setInterval(() => registration.update(), 43200000);
        })
        .catch(err => console.log('service worker not registered', err));
}
